
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class InputItem extends Vue {
  @Prop({ type: String, default: '' }) title!: string
  @Prop({ type: String }) errorMessage!: string
}
